import { createContext } from 'react';
import {
  AppVisibilityObserver,
  SwipeBackActions,
  ScreenOrientationObserver,
  IOSKeyboardObserver,
  DeviceInfo,
} from '@djs';

export type ViewportMode = 'compact' | 'regular';

export interface DUIContextValue {
  appVisibilityObserver: AppVisibilityObserver;
  iOSKeyboardObserver: IOSKeyboardObserver;
  screenOrientationObserver: ScreenOrientationObserver;
  swipeBackActions: SwipeBackActions;
  motionReduced: boolean;
  transparencyReduced: boolean;
  viewportMode: ViewportMode;
  deviceInfo: DeviceInfo;
}

export const duiContextDefaultValue: DUIContextValue = {
  appVisibilityObserver: {} as any,
  iOSKeyboardObserver: {} as any,
  screenOrientationObserver: {} as any,
  swipeBackActions: {} as any,
  motionReduced: false,
  transparencyReduced: false,
  viewportMode: 'regular',
  deviceInfo: {
    mobileOS: null,
    browser: { name: 'other', version: '0.0', isPwaMode: false },
    isInApp: false,
    ua: '',
  },
};

export const DUIContext = createContext<DUIContextValue>(duiContextDefaultValue);
